/* eslint-disable @typescript-eslint/no-unused-expressions */
import { useValidation } from '@application/utils';
import { AnimalTypeEnum } from '@gql/graphql';
import type { BuyerAnimalFormValues } from '@presentation/components';
import type { FormikErrors } from 'formik';
import { set } from 'lodash/fp';

export const useValidateAnimalForm = () => {
  const { requiredMessage } = useValidation();

  const validateAnimalForm = (
    values: BuyerAnimalFormValues,
  ): FormikErrors<BuyerAnimalFormValues> => {
    let errors: FormikErrors<BuyerAnimalFormValues> = {};

    if (!values.type) {
      errors.type = requiredMessage;
    }

    if (!values.birthday) {
      errors.birthday = requiredMessage;
    }

    if (!values.birthdayType) {
      errors.birthdayType = requiredMessage;
    }

    if (!values.gender) {
      errors.gender = requiredMessage;
    }

    if (
      !(values.sensitivities ?? []).length &&
      [AnimalTypeEnum.DOG].includes(values.type as AnimalTypeEnum)
    ) {
      errors.sensitivities = requiredMessage;
    }

    if (!values.name) {
      errors.name = requiredMessage;
    }

    if (values.type === AnimalTypeEnum.DOG && !values.dogInfo?.breedId) {
      errors = set('dogInfo.breedId', requiredMessage, errors);
    }

    return errors;
  };

  return { validateAnimalForm };
};
